// extracted by mini-css-extract-plugin
export default {"actionDetailWrapPopup":"ShiftTable_actionDetailWrapPopup__qQHnU","buttonPopupConfirm":"ShiftTable_buttonPopupConfirm__LCaiN"};